import { apiClient } from '../../utils';
import { handleError } from '..';

export const editComment = async ({ siteId, ri, st }) => {
  try {
    const data = {
      site: siteId,
      ri,
      st,
    };
    await apiClient.post('/merchant/review/edit', {
      data,
    });

    return;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
